<template>
  <sidebar-nav>
    <toggle/>
    <menubar-link :to="{name: 'client-modules', params: {organization: id}}">
      <template slot="name">Modules</template>
      <template slot="icon"><i class="fas fa-folder"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'client-bioreq', params: {organization: id}}">
      <template slot="name">Bioreq</template>
      <template slot="icon"><i class="fas fa-dna"></i></template>
    </menubar-link>
  </sidebar-nav>
</template>

<script>
import menubarLink from '../common/menubar-link'
import sidebarNav from './sidebar-nav'
import toggle from './toggle'

export default {
  components: {
    menubarLink,
    sidebarNav,
    toggle
  },
  computed : {
    id () {
      return this.$route.params.organization
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/client.vue